import { useState } from "react";
import { useTheme } from "../../context/ThemeContext";
import "./ThemeToggle.css";

interface ThemeToggleProps {
  className?: string;
  floating?: boolean;
}

const ThemeToggle = ({
  className = "",
  floating = false,
}: ThemeToggleProps) => {
  const { theme, toggleTheme } = useTheme();
  const [isChanging, setIsChanging] = useState(false);

  const handleToggle = () => {
    setIsChanging(true);
    toggleTheme();

    // Remove changing class after animation
    setTimeout(() => {
      setIsChanging(false);
    }, 500);
  };

  return (
    <button
      className={`theme-toggle ${className} ${isChanging ? "changing" : ""} ${
        floating ? "floating" : ""
      }`}
      onClick={handleToggle}
      aria-label={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
      title={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
      type="button"
    >
      <span className="theme-icon">{theme === "light" ? "🌙" : "☀️"}</span>
    </button>
  );
};

export default ThemeToggle;
